export default __webpack_public_path__ + "static/media/cancel.b2d26622.svg";